<ngx-chat-window-frame>
    <video #video autoplay="1"></video>
</ngx-chat-window-frame>
